import {
  Component,
  ElementRef,
  forwardRef,
  Inject,
  Injector,
  Input,
  Renderer2,
  ViewChild,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import intlTelInput from 'intl-tel-input';

@Component({
  standalone: false,
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrl: './phone-input.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneInputComponent),
      multi: true,
    },
  ],
})
export class PhoneInputComponent
  implements ControlValueAccessor, AfterViewInit
{
  formattedValue = '';
  onChange: any = () => {};
  onTouch: any = () => {};
  public control!: FormControl;
  initContry: any;
  @Input() value: any;
  @ViewChild('intlInput') intlInput!: ElementRef;
  Regpattern: any = /^[+]\d{12}$/;
  constructor(
    @Inject(Injector) private readonly injector: Injector,
    private readonly renderer: Renderer2,
  ) {}

  onInputChange(event: any) {
    let input = event.target.value.replace(/\D/g, ''); // Remove non-digits

    // Format: 123-456-7890
    if (input.length > 6) {
      this.formattedValue = `${input.slice(0, 3)}-${input.slice(3, 6)}-${input.slice(6, 10)}`;
    } else if (input.length > 3) {
      this.formattedValue = `${input.slice(0, 3)}-${input.slice(3)}`;
    } else {
      this.formattedValue = input;
    }
    if (!this.Regpattern.test(this.formattedValue)) {
      const injectedControl = this.injector.get(NgControl);
      injectedControl.control?.setErrors({ pattern: true });
    }

    this.onChange(this.formattedValue); // Emit formatted value or raw digits as preferred
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    this.formattedValue = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initContry = intlTelInput(this.intlInput.nativeElement, {
        allowDropdown: true,
        nationalMode: true,
        initialCountry: 'auto',
        separateDialCode: false,
      });
      const countryData = this.initContry.getSelectedCountryData();
      console.log('New Dial Code:', countryData.dialCode);
      const injectedControl = this.injector.get(NgControl);
      console.log(injectedControl.control?.value);
      if (injectedControl.control?.value.length >= 13) {
        let countryCode = injectedControl.control?.value.slice(0, 3);
        injectedControl.control?.value.slice(-10);
        this.initContry.setNumber(countryCode);
      }
    }, 2000);
  }
}
